import { errorAction, successfulAction } from '@shared/actions';
import { STATUS_CODE } from '@shared/constants';
import getShelvesMenu from '@services/menu/getShelvesMenu';

import { fetchCategoryTreeProducts } from '@utils/shopDetails/index';
import MenuShelvesCategoryTree from '@models/ShopDetails';
import getShelvesMenuLoadStatus from '../selectors/getShelvesMenuLoadStatus';
import MenuShelves from '../models/MenuShelves';
import { FETCH_SHELVES_MENU } from '../actionTypes';

const type = FETCH_SHELVES_MENU;
const errorCode = STATUS_CODE.INTERNAL_ERROR;

const fetchShelvesMenu = ({ shop }) => async (dispatch, getState, axios) => {
  try {
    dispatch({ type });

    const params = {
      shopId: shop.id,
      menuId: shop.menu.id,
    };

    const shelvesLoadStatus = getShelvesMenuLoadStatus(getState());
    if (shelvesLoadStatus && shelvesLoadStatus.count > 0) {
      params.offset = shelvesLoadStatus.count;
    }

    const { success, data, error } = await getShelvesMenu({ axios, ...params });

    if (!success) {
      dispatch(errorAction({ type, error, errorCode }));
      return;
    }

    const menu = data;
    if (menu.data && !data.type) {
      menu.sections = menu.data;
      delete menu.data;
    }

    if (data.type) {
      const result = await fetchCategoryTreeProducts({
        categories: data.categories.map(c => ({ ...c, products: [] })),
        axios,
        shop,
        dispatch,
        type,
      });

      dispatch(
        successfulAction({
          type,
          payload: { menu: MenuShelvesCategoryTree(result) },
        }),
      );
      return;
    }

    dispatch(successfulAction({ type, payload: { menu: MenuShelves(menu) } }));
    return;
  } catch (error) {
    dispatch(errorAction({ type, error, errorCode }));
  }
};

export default fetchShelvesMenu;
